import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const OficinaFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, disabled }) => {
  const __zariContext = React.useContext(ZariContext)
  const [oficinas, setOficinas] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setOficinas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='OFICINA' htmlFor='select-oficina' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idOficina'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-oficina'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting || disabled}
              onChange={e => {
                const val = e.target.value
                const found = oficinas.find(o => o._id === val)
                setFieldValue('_idOficina', val)
                setFieldValue('oficina', found ? found.nombre : '')
              }}
            >
              <option value=''>--SELECCIONAR--</option>
              {oficinas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OficinaFormGroup)
